export default __webpack_public_path__ + "static/four-c29428a63a42d51d449d01c5e004a9fe.jpg";